import adapter from './adapter'
import { collectionGetters } from '@/store/collection'
import { BankAccount } from './model'

const { getAll, getCollection, itemGetter } = collectionGetters(adapter, {
  constructor: data => new BankAccount(data)
})

export default {
  getAll,
  getCollection,
  getBankAccount: itemGetter,
}
